import React from 'react';
import LegalInfo from '../../elements/Body/LegalInfo/LegalInfo';
import privacyPolicyData from '../../../data/legal/privacyPolicy.json';
const PrivacyPolicyPage = () => {
  return (
    <LegalInfo
      title={privacyPolicyData.title}
      sections={privacyPolicyData.sections}
      lastUpdated={privacyPolicyData.lastUpdated}
    />
  );
};
export default PrivacyPolicyPage;
